import useSWR from 'swr'

import { FunnelResponse, GetFunnelVars, UGCFunnelApiPath } from '@/common/api/params/ugcFunnel'

export const useUGCFunnelApi = (vars: GetFunnelVars | undefined) => {
  return useSWR<FunnelResponse, Response, [string, GetFunnelVars] | undefined>(
    vars ? [UGCFunnelApiPath.GET_FUNNEL, vars] : undefined
  )
}
